import { Subject } from 'rxjs'
import { DeviceStatusMessage } from './Devices/types'
import { CFDOnPosEventArg } from './CFD/events'

const deviceStatusSubjects = new Subject<DeviceStatusMessage>()
const cfdOnPosSubjects = new Subject<CFDOnPosEventArg>()

export { deviceStatusSubjects, cfdOnPosSubjects }
